import api from '../../../src/services/feApi.ts';
import { ApiResponse } from "../../types/ApiResponse";
import { MngPinDto } from '../../types/managementStaff/ManagementStaffData';

export const ManagerService = {
    CheckPinCode: async (code: string): Promise<MngPinDto | null> => {
        try {
            const response = await api.post<ApiResponse<MngPinDto>>(
                '/Management/manager/approval',
                { ManagerPin: code }
            );

            const result = response.data;

            if (!result.Success || result.StatusCode !== 200) {
                console.warn("Manager PIN verification failed:", result.Errors || result.Messages);
                return null;
            }

            return result.Data;
        } catch (error: any) {
            if (error.response) {
                const { status, data } = error.response;

                if (status === 404 || data?.ErrorCode === "Unauthorized") {
                    console.error("Unauthorized access:", data?.Errors?.[0] || "Invalid PIN");
                    return null;
                }

                console.error("Server responded with error:", status, data);
                throw new Error(data?.Messages?.[0] || "An unexpected server error occurred.");
            } else if (error.request) {
                throw new Error("No response from server. Please check your internet connection.");
            } else {
                throw new Error(error.message || "Unexpected error occurred.");
            }
        }
    }
};
